import { CheckmarkIconFilled, EmptyCheckmarkIcon, IconProps } from '@va/icons';

export const Checkmark = ({ selected, ...rest }: { selected: boolean } & IconProps) => {
  return selected ? <CheckmarkIconFilled {...rest} /> : <EmptyCheckmarkIcon {...rest} />;
};
